import { ConversationsPriorityFeedQuery } from 'capability-ng-conversations';
import { HoldPriorityFeedQuery } from 'capability-ng-holds';
import { ReportsPriorityFeedQuery } from 'capability-ng-reports';
import { StudyGroupsPriorityFeedQuery } from 'capability-ng-study-groups';
import { SurveyPriorityFeedQuery } from 'capability-ng-survey';
import { AppointmentRequestPriorityFeedQuery, ToDoPriorityFeedQuery } from 'capability-ng-todos';
import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { Query } from 'utility-ts-orm';

export class SumBadgeCountQuery implements IQuery {
  private _result: any;

  constructor(
    private ngConversationsPriorityFeedQuery: ConversationsPriorityFeedQuery,
    private ngAppointmentRequestPriorityFeedQuery: AppointmentRequestPriorityFeedQuery,
    private ngHoldPriorityFeedQuery: HoldPriorityFeedQuery,
    private ngStudyGroupsPriorityFeedQuery: StudyGroupsPriorityFeedQuery,
    private ngSurveyPriorityFeedQuery: SurveyPriorityFeedQuery,
    private ngToDoPriorityFeedQuery: ToDoPriorityFeedQuery,
    private ngReportsPriorityFeedQuery: ReportsPriorityFeedQuery,
    private ngConversationDatastore: any,
    private ngPathItemDatastore: any,
    private ngPathTaskDatastore: any,
    private ngHoldDatastore: any,
    private ngStudygroupsPriorityFeedDatasource: any,
    private ngSurveyDatastore: any,
    private staffTodoListDatastore: any,
    private reminderListDatastore: any,
    private ngApptSummariesDatasource: any,
    private ngNotesDatasource: any,
    private ngProgressReportsDatasource: any
  ) {
    Query.registerQuery(
      this,
      this.ngConversationDatastore,
      this.ngPathItemDatastore,
      this.ngPathTaskDatastore,
      this.ngHoldDatastore,
      this.ngStudygroupsPriorityFeedDatasource,
      this.ngSurveyDatastore,
      this.staffTodoListDatastore,
      this.reminderListDatastore,
      this.ngApptSummariesDatasource,
      this.ngNotesDatasource,
      this.ngProgressReportsDatasource
    );
  }

  run(): this {
    this.ngConversationsPriorityFeedQuery.run();
    this.ngAppointmentRequestPriorityFeedQuery.run();
    this.ngHoldPriorityFeedQuery.run();
    this.ngStudyGroupsPriorityFeedQuery.run();
    this.ngSurveyPriorityFeedQuery.run();
    this.ngToDoPriorityFeedQuery.run();
    this.ngReportsPriorityFeedQuery.run();
    this._result = {
      count:
        this.ngConversationsPriorityFeedQuery.count +
        this.ngAppointmentRequestPriorityFeedQuery.count +
        this.ngHoldPriorityFeedQuery.count +
        this.ngStudyGroupsPriorityFeedQuery.count +
        this.ngSurveyPriorityFeedQuery.count +
        this.ngToDoPriorityFeedQuery.count +
        this.ngReportsPriorityFeedQuery.count
    };
    return this;
  }

  get result() {
    return this._result;
  }
}

angular.module('capability-ng-priority-feed').service('ngSumBadgeCountQuery', SumBadgeCountQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-priority-feed/src/queries/sum_badge_count_query.ts